import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedUserRouts = ({ children }) => {
  const { loading, isAuth,user } = useSelector((state) => state.Users);
  if (loading === false) {
    if (!isAuth) {
      return <Navigate to="/login" replace />;
    } else if(user.role === "user"){
        return children;
    }else{
           return <Navigate to="/" replace />;
    }
 
 
  }
};

export default ProtectedUserRouts;